import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Story from './pages/Story';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import data from './assets/Data';


const root = ReactDOM.createRoot(
  document.getElementById("root")
);

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      {
        data.map((item, index) => {
          return (
            <Route key={index} path={item.slug} element={<Story story={item}/>} />
          );
        })
      }
    </Routes>
  </BrowserRouter>
);
